import { Card, SxProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

import { useTranslation } from "providers/i18n"

import { useMobileUrl } from "hooks/useMobileUrl"
import { usePromotionDetail } from "hooks/promotion/usePromotionDetail"

import { IDetailPageProps } from "components/domains/features/DetailPage"

import { Id } from "@turf/helpers"

interface IPromotionDetailCardProps {
  sx?: SxProps
  promotionId: Id
  onNavigate: () => void
  onBack: () => void
  DetailPageComponent: React.FC<IDetailPageProps>
}

export const PromotionDetailCard = ({
  sx = {},
  promotionId,
  onNavigate,
  onBack,
  DetailPageComponent,
  ...props
}: IPromotionDetailCardProps) => {
  const { t } = useTranslation()

  const { mobileUrl } = useMobileUrl()

  const { promotion } = usePromotionDetail(promotionId as string)

  const theme = useTheme()

  const { styleOverrides } = theme.components[`PromotionDetailCard`] || {}
  const { root, detail } = styleOverrides

  return (
    <Card sx={deepmerge(root, sx)} {...props}>
      <DetailPageComponent
        sx={detail}
        item={promotion}
        headerDetail={t("Promotion Detail")}
        navigationButtonText={t("Get direction")}
        mobileUrl={mobileUrl}
        onBack={onBack}
        onViewLocation={onNavigate}
      />
    </Card>
  )
}
